<template>
    <div>
        <agile
            ref="carousel"
            :class="{ 'big-slide': showing }"
            :nav-buttons="images.length > 1"
            :infinite="images.length > 1"
            :dots="images.length > 1"
        >
            <div
                v-for="image in images"
                :key="image._id"
                :class="{ 'big-slide': showing }"
                class="slide"
            >
                <!--<img
                    :src="image.url"
                    :class="{ 'big-slide mx-auto': showing }"
                    loading="lazy"
                    alt
                />-->
                <div class="img-carousel-element" :style="getBackground(image.url)" @click="$emit('zoomImage',image.url)"/>
            </div>
            <template slot="prevButton">
                <span class="icon is-large">
                    <i class="mdi mdi-48px mdi-chevron-left"></i>
                </span>
            </template>
            <template slot="nextButton">
                <span class="icon is-large">
                    <i class="mdi mdi-48px mdi-chevron-right"></i>
                </span>
            </template>
        </agile>
    </div>
</template>

<script>
import { VueAgile } from 'vue-agile';
export default {
    components: {
        agile: VueAgile,
    },
    props: {
        images: {
            type: Array,
            default() {
                return [];
            },
        },
        showing: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            slideWidth:380,
            slideHeight:214,
        };
    },
    mounted() {
        
        this.$nextTick(function () {
            if(this.$refs.carousel){
                this.$refs.carousel.reload();
                // console.log("slide widht",this.$refs.carousel.$el.clientWidth)
                this.slideWidth=this.$refs.carousel.$el.clientWidth
                this.slideHeight=(9*this.$refs.carousel.$el.clientWidth)/16
            }
        });
    },
    methods: {
        getBackground(url){
            return "background-image: url("+url+"); background-size: cover; background-repeat: no-repeat; background-position: center center; height:"+this.slideHeight+"px; width:"+this.slideWidth+"px;";
        }
    },
};
</script>

<style lang="sass" scoped>
@import "src/assets/sass/slider"
.slide
  display: block
  //max-height: 20rem
  text-align: center

.big-slide
  max-height: 35rem !important

::v-deep .agile
  //max-height: 20rem
  max-width: 100%
  margin: 0 auto

::v-deep .agile.big-slide
  max-height: 35rem
  max-width: 760px


::v-deep .agile .agile__slides .img-carousel-element 
    max-height: 150px
    max-width: 100%

</style>
